export default __webpack_public_path__ + "static/media/link_icon.eb393814.png";